export const APP_NAME = 'KellerConnect';
